import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SowDetailsComponent } from './sow-details.component';

const routes: Routes = [{ path: '', component: SowDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SowDetailsRoutingModule {}
